import React, { useEffect, useState } from "react";

export default function ClipTitle(props) {
    return (
        <tr>
            <td
                className="title title-single"
                colSpan="6"
                style={{
                    height: "25px",
                    fontSize: "12px",
                    textAlign: "center",
                    padding: "8px",
                }}
            >
                <span className="game-info">
                    {props.playInfo.gameTypeName} &nbsp;
                    [ {props.playInfo.gameDay} &nbsp;
                    {/* {props.playInfo.pitcherTeamName} : {props.playInfo.batterTeamName} &nbsp; */}
                    {props.useLang === "en"
                        ? (props.playInfo.inningTb == "0" ? props.playInfo.batterTeamShortName : props.playInfo.pitcherTeamShortName) 
                        : (props.playInfo.inningTb == "0" ? props.playInfo.batterTeamName :props.playInfo.pitcherTeamName)}
                    :
                    {props.useLang === "en"
                        ? (props.playInfo.inningTb == "0" ? props.playInfo.pitcherTeamShortName : props.playInfo.batterTeamShortName )
                        : (props.playInfo.inningTb == "0" ? props.playInfo.pitcherTeamName :props.playInfo.batterTeamName)}{" "}
                    ]
                </span>
                &nbsp;
                <span className="turn-info">
                    {props.playInfo.inning}
                    {props.cookie.getLanguage(props.useLang, "shortInning")}
                    {props.playInfo.inningTb == 0
                        ? props.cookie.getLanguage(props.useLang, "top")
                        : props.cookie.getLanguage(props.useLang, "bottom")}
                    &nbsp;
                    {props.playInfo.batInningTurn}
                    {props.useLang === "en" ? "PA" : "번째"} &nbsp;
                </span>
                <span className="player-info">
                    {/* #{props.playInfo.pitcherBacknum} &nbsp; */}
                    {/* (언어가 영어일 경우 & 투수가 외국인일 경우 조건문 생략) */}
                    {props.useLang === "en"
                        ? props.playInfo.pitcherForeignerYn === "Y"
                            ? props.playInfo.pitcherLastName
                            : props.playInfo.pitcherLastName +
                              " " +
                              props.playInfo.pitcherShortName
                        : props.playInfo.pitcherName}
                    ({props.playInfo.pitchingHand}) vs.
                    {/* #{props.playInfo.batterBacknum} &nbsp; */}
                    {/* (언어가 영어일 경우 & 타자가 외국인일 경우 조건문 생략) */}
                    {props.useLang === "en"
                        ? props.playInfo.batterForeignerYn === "Y"
                            ? props.playInfo.batterLastName
                            : props.playInfo.batterLastName +
                              " " +
                              props.playInfo.batterShortName
                        : props.playInfo.batterName}
                    ({props.playInfo.battingHand})
                </span>
            </td>
        </tr>
    );
}
